/**
 * Created by jiachenpan on 16/11/18.
 */
import { getData } from "../api/bigscreen";
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
        date = time;
    } else {
        if (("" + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
            return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        if (result.length > 0 && value < 10) {
            value = "0" + value;
        }
        return value || 0;
    });
    return time_str;
}

export function formatTime(time, option) {
    time = +time * 1000;
    const d = new Date(time);
    const now = Date.now();

    const diff = (now - d) / 1000;

    if (diff < 30) {
        return "刚刚";
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + "分钟前";
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + "小时前";
    } else if (diff < 3600 * 24 * 2) {
        return "1天前";
    }
    if (option) {
        return parseTime(time, option);
    } else {
        return (
            d.getMonth() +
            1 +
            "月" +
            d.getDate() +
            "日" +
            d.getHours() +
            "时" +
            d.getMinutes() +
            "分"
        );
    }
}

export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path);
}

export function deepClone(source) {
    if (!source && typeof source !== "object") {
        throw new Error("error arguments", "shallowClone");
    }
    const targetObj = source.constructor === Array ? [] : {};
    Object.keys(source).forEach((keys) => {
        if (source[keys] && typeof source[keys] === "object") {
            targetObj[keys] = deepClone(source[keys]);
        } else {
            targetObj[keys] = source[keys];
        }
    });
    return targetObj;
}

function padLeftZero(str) {
    return ("00" + str).substr(str.length);
}

/**
 *  生成uuid
 */
export function getUUID() {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); // use high-precision timer if available
    }
    let uuid = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
    );
    return uuid;
}
// crypto 加解密
const CryptoJS = require("crypto-js"); // 引用AES源码js

const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); // 十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse("ABCDEF1234123412"); // 十六位十六进制数作为密钥偏移量

// 解密方法
export function Decrypt(word) {
    const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    const decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    const inside = decryptedStr.toString();
    const i = inside.substr(-32);
    return inside.split(i)[0];
}

// 加密方法
export function Encrypt(word) {
    const srcs = CryptoJS.enc.Utf8.parse(word + getUUID());
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.ciphertext.toString().toUpperCase();
}

/**
 * 导出文件接口请求后的的公用方法
 * res 请求后返回的response
 * fileName 文件名
 */
export function downloadBlob(res, fileName) {
    const blob = new Blob([res.data], {
        type: "application/vnd.ms-excel;charset=utf-8",
    });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // ie
        navigator.msSaveBlob(blob, fileName || "文件" + ".xlsx");
    } else {
        const link = document.createElement("a");
        // let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        fileName && (link.download = fileName + ".xlsx"); // 下载的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

// 下载文件
export function downloadFile(obj, name, suffix) {
    const url = window.URL.createObjectURL(new Blob([obj]));
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    const fileName = parseTime(new Date()) + "-" + name + "." + suffix;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
function isArrayFn(value) {
    if (typeof Array.isArray === "function") {
        return Array.isArray(value);
    } else {
        return Object.prototype.toString.call(value) === "[object Array]";
    }
}
export function objToOne(obj) {
    let tmpData = {};
    for (let index in obj) {
        if (typeof obj[index] == "object" && !isArrayFn(obj[index])) {
            let resObj = objToOne(obj[index]);
            Object.assign(tmpData, resObj); // 这里使用对象合并
        } else {
            tmpData[index] = obj[index];
        }
    }
    return tmpData;
}
// 查询echarts 数据
export function queryEchartsData(params) {
    // console.log(params);
    return new Promise(async (resolve) => {
        const { code, data } = await getData(params);
        if (code != 200) return;
        const analysisData = analysisChartsData(params, data);
        resolve(analysisData);
    });
}
// 解析不同图标的数据
function analysisChartsData(params, data) {
    // widget-barchart 柱线图、widget-linechart 折线图、 widget-barlinechart 柱线图
    // widget-piechart 饼图、widget-funnel 漏斗图
    // widget-text 文本框
    // widge-table 表格(数据不要转)
    // widget-stackchart 堆叠图
    // widget-heatmap 热力图
    // widget-mapline 中国地图-路线图
    // widget-radar 雷达图
    const chartType = params.chartType;
    if (
        chartType == "widget-barchart" ||
        chartType == "widget-linechart" ||
        chartType == "widget-barlinechart"
    ) {
        return barOrLineChartFn(params.chartProperties, data);
    } else if (chartType == "widget-piechart" || chartType == "widget-funnel") {
        return piechartFn(params.chartProperties, data);
    } else if (chartType == "widget-text") {
        return widgettext(params.chartProperties, data);
    } else if (chartType == "widget-stackchart") {
        return stackChartFn(params.chartProperties, data);
    } else if (chartType == "widget-coord") {
        return coordChartFn(params.chartProperties, data);
    } else if (chartType == "widget-linemap") {
        return linemapChartFn(params.chartProperties, data);
    } else if (chartType == "widget-radar") {
        return radarChartFn(params.chartProperties, data);
    } else {
        return data;
    }
}
// 柱状图、折线图、柱线图
function barOrLineChartFn(chartProperties, data) {
    const ananysicData = {};
    const xAxisList = [];
    const series = [];
    for (const key in chartProperties) {
        const obj = {};
        const seriesData = [];
        const value = chartProperties[key];
        obj["type"] = value;
        obj["name"] = key;
        for (let i = 0; i < data.length; i++) {
            if (value.startsWith("xAxis")) {
                // 代表为x轴
                xAxisList[i] = data[i][key];
            } else {
                // 其他的均为series展示数据
                seriesData[i] = data[i][key];
            }
        }
        obj["data"] = seriesData;
        if (!obj["type"].startsWith("xAxis")) {
            series.push(obj);
        }
    }
    ananysicData["xAxis"] = xAxisList;
    ananysicData["series"] = series;
    return ananysicData;
}
//堆叠图
function stackChartFn(chartProperties, data) {
    const ananysicData = {};
    const series = [];
    //全部字段字典值
    const types = Object.values(chartProperties);
    //x轴字段、y轴字段名
    const xAxisField = Object.keys(chartProperties)[types.indexOf("xAxis")];
    const yAxisField = Object.keys(chartProperties)[types.indexOf("yAxis")];
    const dataField = Object.keys(chartProperties)[types.indexOf("bar")];
    //x轴数值去重，y轴去重
    const xAxisList = this.setUnique(data.map((item) => item[xAxisField]));
    const yAxisList = this.setUnique(data.map((item) => item[yAxisField]));
    const dataGroup = this.setGroupBy(data, yAxisField);
    for (const key in chartProperties) {
        if (
            chartProperties[key] !== "yAxis" &&
            !chartProperties[key].startsWith("xAxis")
        ) {
            Object.keys(dataGroup).forEach((item) => {
                const data = new Array(xAxisList.length).fill(0);
                dataGroup[item].forEach((res) => {
                    data[xAxisList.indexOf(res[xAxisField])] = res[key];
                });
                series.push({
                    name: yAxisList[item],
                    type: chartProperties[key],
                    data: data,
                });
            });
        }
    }
    ananysicData["xAxis"] = xAxisList;
    ananysicData["series"] = series;
    return ananysicData;
}
// 饼图、漏斗图
function piechartFn(chartProperties, data) {
    const ananysicData = [];
    for (let i = 0; i < data.length; i++) {
        const obj = {};
        for (const key in chartProperties) {
            const value = chartProperties[key];
            if (value === "name") {
                obj["name"] = data[i][key];
            } else {
                obj["value"] = data[i][key];
            }
        }
        ananysicData.push(obj);
    }
    return ananysicData;
}
function widgettext(chartProperties, data) {
    const ananysicData = [];
    for (let i = 0; i < data.length; i++) {
        const obj = {};
        for (const key in chartProperties) {
            const value = chartProperties[key];
            if (value === "name") {
            } else {
                obj["value"] = data[i][key];
            }
        }
        ananysicData.push(obj);
    }
    return ananysicData;
}
// 坐标系数据解析
function coordChartFn(chartProperties, data) {
    const ananysicData = {};
    let series = [];
    //全部字段字典值
    const types = Object.values(chartProperties);
    //x轴字段、y轴字段、数值字段名
    const xAxisField = Object.keys(chartProperties)[types.indexOf("xAxis")];
    const yAxisField = Object.keys(chartProperties)[types.indexOf("yAxis")];
    const dataField = Object.keys(chartProperties)[types.indexOf("series")];
    //x轴数值去重，y轴去重
    const xAxisList = this.setUnique(data.map((item) => item[xAxisField]));
    const yAxisList = this.setUnique(data.map((item) => item[yAxisField]));
    ananysicData["xAxis"] = xAxisList;
    ananysicData["yAxis"] = yAxisList;
    for (const i in data) {
        series[i] = [
            data[i][xAxisField],
            data[i][yAxisField],
            data[i][dataField],
        ];
    }
    ananysicData["series"] = series;
    return ananysicData;
}
// 中国地图。路线图数据解析，适合source、target、value
function linemapChartFn(chartProperties, data) {
    const ananysicData = [];
    for (let i = 0; i < data.length; i++) {
        const obj = {};
        for (const key in chartProperties) {
            const value = chartProperties[key];
            if (value === "source") {
                obj["source"] = data[i][key];
            } else if (value === "target") {
                obj["target"] = data[i][key];
            } else {
                obj["value"] = data[i][key];
            }
        }
        ananysicData.push(obj);
    }
    return ananysicData;
}
function radarChartFn(chartProperties, data) {
    const ananysicData = {};
    // 字段名
    const radarField = [];
    let nameField;
    for (const key in chartProperties) {
        if (chartProperties[key] == "radar") {
            radarField.push(key);
        }
        if (chartProperties[key] == "name") {
            nameField = key;
        }
    }
    // 拿到数值
    ananysicData["name"] = nameField;
    ananysicData["keys"] = radarField;
    ananysicData["value"] = data;
    return ananysicData;
}
